import React, { useEffect, useState, useRef } from "react";
import Mensaje from "./Mensaje";
import moment from "moment";

/**
 * `hasMore` (from EntradasContext) says whether older entradas can still be
 * loaded; when it is not passed, the legacy `max` total count is used.
 */
const Entradas = ({
  max,
  hasMore,
  entradas,
  idProyecto,
  idAdjunto,
  scrollCallback,
}) => {
  const refContainer = useRef();
  const [reachedTop, setReachedTop] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if (Array.isArray(entradas) && firstLoad) {
      const container = refContainer.current;
      refContainer.current.scrollTo({
        top: container.offsetHeight * 10,
      });
      setFirstLoad(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entradas]);

  const renderEntradas = () => {
    if (Array.isArray(entradas)) {
      if (entradas.length === 0) {
        return (
          <div className="row">
            <p className="px-0" style={{ color: "#acacac" }}>
              No hay comentarios creados
            </p>
          </div>
        );
      }
      const grouped = [];
      entradas.forEach((entrada) => {
        const adjuntoOnly =
          entrada.Adjunto !== null &&
          (entrada.contenido === null || entrada.contenido === "");
        const last = grouped[grouped.length - 1];
        const lastAdjuntoOnly =
          last &&
          last.contenido === null &&
          Array.isArray(last.adjuntos) &&
          last.adjuntos.length > 0;
        const sameUser = last && last.idUsuario === entrada.idUsuario;
        const sameMinute =
          last &&
          moment(last.createdAt).format("YYYY-MM-DD HH:mm") ===
            moment(entrada.createdAt).format("YYYY-MM-DD HH:mm");
        if (adjuntoOnly && lastAdjuntoOnly && sameUser && sameMinute) {
          last.adjuntos.push(entrada.Adjunto);
          return;
        }
        const next = { ...entrada };
        next.adjuntos = entrada.Adjunto !== null ? [entrada.Adjunto] : [];
        grouped.push(next);
      });
      let previous;
      let follow;
      let fechaAnterior;
      return grouped.map((entrada) => {
        if (previous) {
          fechaAnterior = previous.createdAt;
          follow = previous.idUsuario === entrada.idUsuario;
        }
        previous = entrada;
        return (
          <Mensaje
            key={`mensaje-${entrada.idEntrada}`}
            fechaAnterior={fechaAnterior}
            idProyecto={idProyecto}
            idAdjunto={idAdjunto}
            entrada={entrada}
            follow={follow}
          />
        );
      });
    }
    return <div className="spinner-border"></div>;
  };

  const handleScroll = () => {
    const container = refContainer.current;
    const scrollTop = container.scrollTop;
    if (scrollTop === 0 && Array.isArray(entradas)) {
      const canLoadMore =
        typeof hasMore === "boolean" ? hasMore : entradas.length < max;
      if (canLoadMore) {
        let offset = entradas.length;
        if (typeof scrollCallback === "function") {
          scrollCallback(offset);
        }
      } else {
        setReachedTop(true);
      }
    }
  };

  return (
    <div
      id="entradas"
      ref={refContainer}
      onScroll={handleScroll}
      className="container-fluid h-100 pb-2"
    >
      {(typeof hasMore === "boolean" ? !hasMore : reachedTop) && (
        <p className="text-center">No hay entradas más antiguas.</p>
      )}
      {renderEntradas()}
    </div>
  );
};

export default Entradas;
